module.exports = __webpack_public_path__ + "img/man1.25a7961d.png";